import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  LECTURE_CONTENT_OPTIONS,
  LECTURE_CONTENT_TYPES,
  LectureContentInput,
  literatureResourceSelector,
  postLectureContentSelector,
  preLectureContentSelector,
  setLiteratureResource,
  setPostLectureContent,
  setPreLectureContent,
} from 'features/classCreation';
import Field from 'components/Field';
import LectureContentChip from '../LectureContentChip';

export default function LectureContentInputGroup({ errors }) {
  const dispatch = useDispatch();
  const preLectureContent = useSelector(preLectureContentSelector);
  const postLectureContent = useSelector(postLectureContentSelector);
  const literatureResource = useSelector(literatureResourceSelector);

  const handlePreLectureContentChange = useCallback(
    (content) => {
      dispatch(setPreLectureContent(content));
    },
    [dispatch]
  );
  const handlePostLectureContentChange = useCallback(
    (content) => {
      dispatch(setPostLectureContent(content));
    },
    [dispatch]
  );
  const handleLiteratureResourceChange = useCallback(
    (content) => {
      dispatch(setLiteratureResource(content));
    },
    [dispatch]
  );
  return (
    <Field
      label="Lecture Details"
      className="m-b-l"
    >
      <div className="m-b-s">
        {Object.keys(LECTURE_CONTENT_OPTIONS).map((contentType, index) => (
          <LectureContentChip
            contentType={contentType}
            title={LECTURE_CONTENT_OPTIONS[contentType].label}
            key={contentType}
          />
        ))}
      </div>
      {preLectureContent && (
        <Field
          label="Pre Lecture Content"
          name="pre_lecture_content"
          serverErrors={errors}
          labelClassName="hint normal"
        >
          <LectureContentInput
            contentType={LECTURE_CONTENT_TYPES.preLecture}
            value={preLectureContent}
            placeholder="Enter Pre Lecture Content"
            onChange={handlePreLectureContentChange}
          />
        </Field>
      )}
      {postLectureContent && (
        <Field
          label="Post Lecture Content"
          name="post_lecture_content"
          labelClassName="hint normal"
          serverErrors={errors}
        >
          <LectureContentInput
            contentType={LECTURE_CONTENT_TYPES.postLecture}
            value={postLectureContent}
            placeholder="Enter Post Lecture Content"
            onChange={handlePostLectureContentChange}
          />
        </Field>
      )}
      {literatureResource && (
        <Field
          label="Research Papers"
          name="literature_resource"
          labelClassName="hint normal"
          serverErrors={errors}
        >
          <LectureContentInput
            contentType={LECTURE_CONTENT_TYPES.literatureResource}
            value={literatureResource}
            placeholder="Enter Research Papers"
            onChange={handleLiteratureResourceChange}
          />
        </Field>
      )}
    </Field>
  );
}
